import { Map as ImmMap } from 'immutable';
import { CLOSE_STORE_MODAL, OPEN_STORE_MODAL, SAVE_SELECTED_LOCATION } from './constants';

export const initialState = new ImmMap({
	storeModalOpen: false,
});

const storeModalReducer = (state = initialState, action) => {
	switch (action.type) {
		case CLOSE_STORE_MODAL: {
			return state.set('storeModalOpen', false);
		}
		case OPEN_STORE_MODAL: {
			return state.set('storeModalOpen', true);
		}
		case SAVE_SELECTED_LOCATION: {
			return state.set('selectedLocation', action.isSavingStore);
		}
		default:
			return state;
	}
};

export default storeModalReducer;
